import { LoanFormData, FormErrors } from '../types';
import i18n from '../i18n/config';

export const validateForm = (formData: Partial<LoanFormData>): FormErrors => {
  const errors: FormErrors = {};
  
  // Validate First Name
  if (!formData.firstName) {
    errors.firstName = 'Vārds ir obligāts';
  } else if (formData.firstName.length < 2) {
    errors.firstName = 'Vārds ir pārāk īss';
  }
  
  // Validate Last Name
  if (!formData.lastName) {
    errors.lastName = 'Uzvārds ir obligāts';
  } else if (formData.lastName.length < 2) {
    errors.lastName = 'Uzvārds ir pārāk īss';
  }
  
  // Validate Personal Code
  if (!formData.personalCode) {
    errors.personalCode = 'Personas kods ir obligāts';
  } else if (!/^\d{6}-\d{5}$/.test(formData.personalCode)) {
    errors.personalCode = 'Nepareizs personas koda formāts';
  }
  
  // Validate Email
  if (!formData.email) {
    errors.email = 'E-pasts ir obligāts';
  } else {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const email = formData.email.toLowerCase();
    const isValidFormat = emailRegex.test(email);
    
    if (!isValidFormat) {
      errors.email = 'Nepareizs e-pasta formāts';
    }
  }

  // Validate Phone
  if (!formData.phone) {
    errors.phone = 'Telefons ir obligāts';
  } else if (!/^\+[1-9]\d{1,14}$/.test(formData.phone)) {
    errors.phone = 'Nepareizs tālruņa numura formāts';
  } else if (formData.phone.length < 12) {
    // Phone number should be at least 8 characters (country code + 7 digits)
    errors.phone = 'Nepareizs tālruņa numura formāts';
    }

  // Validate City
  if (!formData.city) {
    errors.city = 'Pilsēta ir obligāta';
  } else if (formData.city.length < 2) {
    errors.city = 'Pilsēta ir pārāk īsa';
  }

  if (!formData.declaredAddress?.trim()) {
    errors.declaredAddress = 'Lūdzu ievadiet derīgu adresi';
  }

  if (!formData.addressesMatch && !formData.facticalAddress?.trim()) {
    errors.facticalAddress = 'Faktiskā adrese ir obligāta';
  }
  
  // Validate Bank Account
  if (formData.bankAccount && !/^[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{7}([A-Z0-9]?){0,16}$/.test(formData.bankAccount)) {
    errors.bankAccount = 'Nepareizs IBAN formāts';
  }
  
  // Validate Terms
  if (!formData.agreeToTerms) {
    errors.agreeToTerms = 'Jums jāpiekrīt noteikumiem un nosacījumiem';
  }

  // Validate Family Status
  if (!formData.familyStatus) {
    errors.familyStatus = 'Ģimenes statuss ir obligāts';
  }

  // Validate Job Type
  if (!formData.jobType) {
    errors.jobType = 'Darba veids ir obligāts';
  }

  // Validate Monthly Income (required, must be greater than zero)
  if (formData.monthlyIncome === '' || formData.monthlyIncome === undefined || formData.monthlyIncome === null) {
    errors.monthlyIncome = 'Ikmēneša ienākumi ir obligāti';
  } else if (formData.monthlyIncome <= 0) {
    errors.monthlyIncome = 'Ikmēneša ienākumiem jābūt lielākiem par 0';
  }

  // Validate Monthly Payments (required, zero is allowed)
  if (formData.monthlyPayments === '' || formData.monthlyPayments === undefined || formData.monthlyPayments === null) {
    errors.monthlyPayments = 'Ikmēneša maksājumi ir obligāti';
  } else if (formData.monthlyPayments < 0) {
    errors.monthlyPayments = 'Ikmēneša maksājumi ir obligāti';
  }

  // Validate Bank Authorization
  if (formData.authorizeBankAccess && !formData.selectedBank) {
    errors.selectedBank = 'Lūdzu izvēlieties banku';
  }
  
  return errors;
};

export const isFormValid = (errors: FormErrors): boolean => {
  return Object.keys(errors).length === 0;
};

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatPeriod = (months: number): string => {
  return `${months} mēneši`;
};

export const formatPersonalCode = (value: string): string => {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '');
  
  // Limit to 11 digits (6 + 5)
  const limitedDigits = digits.slice(0, 11);
  
  // Format as DDMMYY-XXXXX
  if (limitedDigits.length <= 6) {
    return limitedDigits;
  } else {
    return `${limitedDigits.slice(0, 6)}-${limitedDigits.slice(6)}`;
  }
};